export type Instrument = {
  item_id: string;
  canonical_name: string;
  category?: string;
  scale?: string;
  description?: string;
};

export type InstrumentsResponse = {
  version: number | string | null;
  last_updated: string | null;
  items: Instrument[];
};

export function filterInstruments(list: Instrument[], query: string): Instrument[] {
  const q = query.toLowerCase().trim();
  if (!q) return list;
  return list.filter((i) =>
    i.item_id.toLowerCase().includes(q) ||
    (i.canonical_name || '').toLowerCase().includes(q) ||
    (i.category || '').toLowerCase().includes(q) ||
    (i.scale || '').toLowerCase().includes(q));
}
